<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.authTemplates'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="authTemplateForm"
          :model="authTemplate"
          label-width="60px"
          size="small"
        >
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.name')"
                    :prop="'name'"
                    :rules="[
                      {
                        required: true,
                        validator: validateNameEdit,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="authTemplate.name"
                      :placeholder="$t('text.name')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset>
              <legend>{{ $t("action.auth") }}</legend>
              <div
                v-for="(sys, index) of permissions"
                :key="sys.name"
                class="pd10-lr"
                style="border-bottom: 1px solid #e6ebf5"
              >
                <div
                  style="height: 40px; line-height: 40px; clear：both"
                  @click="expend(sys, index)"
                >
                  <span class="float-left">
                    {{ sys.label }}
                  </span>
                  <span class="float-right">
                    <i
                      v-if="sys.show"
                      :class="
                        sys.show == true
                          ? 'el-icon-arrow-down'
                          : 'el-icon-arrow-right'
                      "
                    />
                  </span>
                </div>
                <div v-if="sys.show" class="pd10-lr">
                  <div v-for="item of sys.items" :key="item.name" class="mgb15">
                    <div class="mgb10 grey-dark">
                      <el-checkbox
                        v-model="checkedPermissions"
                        :label="item.name"
                        @change="checkPermission(item)"
                      >
                        {{ item.label }}
                      </el-checkbox>
                    </div>
                    <el-row class="pd20-lr" :gutter="10">
                      <el-col
                        v-for="i of item.items"
                        :key="i.name"
                        :span="8"
                        class="mgb10"
                      >
                        <el-checkbox
                          v-model="checkedAuth"
                          :label="i.name"
                          class="font16"
                        >
                          {{ i.label }}
                        </el-checkbox>
                        <div
                          v-if="i.desc != null"
                          class="mgt5 font14 grey-shallow"
                        >
                          {{ i.descc }}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >

            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Permit from "@/utils/permit.js";
import { page } from "@/utils/mixins.js";
import BackButton from "@/components/BackButton";
import AuthTemplate from "@/api/authTemplate.js";

export default {
  mixins: [page],
  components: {
    BackButton,
  },
  data() {
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(new Error(self.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      AuthTemplate.findByName({ name: value }).then(function (res) {
        if (res.data.code == 200) {
          callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        } else {
          callback();
        }
      });
    };

    return {
      validateNameEdit: validateNameEdit,
      permissions: Permit.permissions(),
      authTemplate: {},
      checkedAuth: [],
      checkedPermissions: [],
      saveDoing: false,
    };
  },
  mounted() {},
  created() {},

  methods: {
    expend(sys, index) {
      this.permissions[index].show = !this.permissions[index].show;
    },
    checkPermission(item) {
      const self = this;
      const currentPermissionAuths = item.items.map((i) => i.name);
      if (self.checkedPermissions.indexOf(item.name) !== -1) {
        for (const currentPermissionAuth of currentPermissionAuths) {
          if (self.checkedAuth.indexOf(currentPermissionAuth) === -1) {
            self.checkedAuth.push(currentPermissionAuth);
          }
        }
      } else {
        for (const currentPermissionAuth of currentPermissionAuths) {
          if (self.checkedAuth.indexOf(currentPermissionAuth) !== -1) {
            self.checkedAuth.splice(
              self.checkedAuth.indexOf(currentPermissionAuth),
              1
            );
          }
        }
      }
    },
    saveSubmit() {
      let self = this;
      self.$refs.authTemplateForm.validate((valid) => {
        if (valid) {
          self.authTemplate.authJsons = JSON.stringify(self.checkedAuth);

          self.saveDoing = true;
          AuthTemplate.create(self.authTemplate).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.saveSuccess"),
                type: "success",
              });
              self.$router.push({
                name: "perferenceAuthTemplates",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>